import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { EkoElement } from "@/utilities/element";
import style from "./command-menu.css?inline";
import "@/components/overlay";

@customElement("eko-command-menu")
class CommandMenu extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  private handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      this.handleClose();
    }
  };

  @property({ reflect: true, type: Boolean }) collapsed = false;
  @property({ reflect: true, type: Boolean }) open = false;
  @property({ reflect: true }) position: "top" | "center" | "bottom" = "top";

  private handleClose(event?: Event) {
    if (event && event.target !== event.currentTarget) return;

    const allowed = this.dispatchEvent(new Event("cancel", { cancelable: true }));

    if (allowed) {
      this.hide();
    }
  }

  connectedCallback(): void {
    super.connectedCallback();

    this.setAttribute("role", "dialog");
    this.setAttribute("aria-label", "Command Menu");

    document.addEventListener("keydown", this.handleKeyDown);
  }

  hide() {
    this.open = false;

    this.dispatchEvent(new Event("close"));
  }

  render() {
    return html`<eko-overlay @close=${this.handleClose} part="overlay">
      <div class="eko-command-menu" tabindex="0" part="root">
        <slot></slot>
      </div>
    </eko-overlay>`;
  }

  show() {
    this.open = true;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-command-menu": CommandMenu;
  }
}

export default CommandMenu;
